module.exports = __webpack_public_path__ + "img/10.c94146cb.jpg";